import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCart = (props) => {

    const { cart, setCart, selectedCurrency, cartItem, secondaryTotalPrice, mainTotalPrice,
         secondaryNetPrice, mainNetPrice, secondaryvatAmount, mainvatAmount } = props;

    const { userData, settingData, salableData, rateFromToCurrency, secondaryCurrency, mainCurrency } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [spinning, setSpinning] = React.useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");

    // Add new row
    const handleAddRow = () => {
        setCart((prevCart) => [...prevCart, cartItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()

        if (cart?.length > 1) {
            const updatedRows = cart.slice(0, -1);
            setCart(updatedRows);
        } else {
            toast.error('you need at least one item')
        }


    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedCart = [...cart];

        updatedCart[index][field] = value;

        updatedCart[index].netPrice = parseFloat(updatedCart[index].netPrice);
        updatedCart[index].vatAmount = parseFloat(updatedCart[index].netPrice * updatedCart[index].vatPercentage / 100);

        updatedCart[index].totalPrice = parseFloat(updatedCart[index].netPrice) + parseFloat(updatedCart[index].vatAmount);


        setCart(updatedCart);
    }





    return (

        <div>

            <Spin spinning={spinning} fullscreen />


            <Row >


                <Col>
                    <Form.Label>Details</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Total </Form.Label>
                </Col>


                <Col>
                    <Form.Label>VAT %</Form.Label>
                </Col>

            </Row>



            {cart?.map((row, index) => (


                <Row className="g-1 mb-1" key={index}>



                    {/* Details */}
                    <Col>
                        <Form.Control as="textarea" rows={1}
                            value={cart[index]?.details}
                            onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                        />
                    </Col>

                    {/* total cost */}
                    <Col>
                        <Form.Control type="number" name="total" id="total"
                            value={cart[index]?.netPrice}
                            onChange={(e) => handleRowChange(index, e.target.value, 'netPrice')} />
                    </Col>


                    {/* VAT % */}
                    <Col>
                        <Form.Control type="number" className="inputColor" min={0} step='any' value={cart[index]?.vatPercentage}
                            onChange={(e) => handleRowChange(index, e.target.value, 'vatPercentage')}
                            required
                        />
                    </Col>

                </Row>





            ))}





            <Row className="mb-4">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('cart')} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'cart')} />

                </Col>

            </Row>


            <Row className='g-0'>

                <Col md={7}>
                </Col>

                <Col md={1}>
                    <Form.Label >
                        <h6>Total:</h6>
                    </Form.Label>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(mainNetPrice)} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(secondaryNetPrice)} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>


            <Row className='g-0'>

                <Col md={7}>
                </Col>

                <Col md={1}>
                    <Form.Label >
                        <h6>VAT:</h6>
                    </Form.Label>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(mainvatAmount)} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(secondaryvatAmount)} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>



            <Row className='g-0'>

                <Col md={7}>  
                </Col>

                <Col md={1}>
                    <Form.Label >
                        <h6>Net Total:</h6>
                    </Form.Label>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(mainTotalPrice)} disabled />
                        <InputGroup.Text>{mainCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
                <Col md={2}>
                    <InputGroup>
                        <Form.Control type="text" value={numberFormatter(secondaryTotalPrice)} disabled />
                        <InputGroup.Text>{secondaryCurrency?.symbol}</InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>

        </div>

    )
}


export default InvoiceCart;